export const RESOLVE_LOG_ENTRY = 'resolve_log_entry';
export const TRIGGER_LOG_ENTRY = 'trigger_log_entry';
export const ANNOTATE_LOG_ENTRY = 'annotate_log_entry';
export const LINK_LOG_ENTRY = 'link_log_entry';
export const UNLINK_LOG_ENTRY = 'unlink_log_entry';
